import goodsForRecordApi from "@/api/goodsForRecordApi";

const goodsForRecordStore = {
  namespaced: true,
  state: {
    declareList: []
  },
  mutations: {},
  actions: {
    declareGoodsList({ commit }, request) {
      return goodsForRecordApi.list({ request }).then(res => {
        return res;
      });
    },
    storeDeclareGoods({ commit }, request) {
      return goodsForRecordApi.store({ request }).then(res => res);
    },
    importPreview({ commit }, request) {
      return goodsForRecordApi
        .importPreview({ fileUrl: request })
        .then(res => res);
    },
    batchImport({ commit }, request) {
      return goodsForRecordApi.batchImport({ request });
    },
    sendWmsApi({ commit }, customsDeclareGoodsId) {
      return goodsForRecordApi.sendWms({ customsDeclareGoodsId });
    },
    exportDeclareGoods({ commit }, request) {
      return goodsForRecordApi.exportDeclareGoods({ request });
    }
  }
};

export default goodsForRecordStore;
